<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">
                {{ $t("SERVICECENTERS.EDIT_SERVICECENTER") }}
              </h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <service-center-form
              :loading="loading"
              :serviceCenterData="serviceCenter"
              :formErrors="formErrors"
              @serviceCenterSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import ServiceCenterForm from "./partials/ServiceCenterForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultServiceCenter from "./defaultServiceCenter";

export default {
  layout: "DashboardLayout",

  components: { ServiceCenterForm },

  mixins: [alertLeave],

  data() {
    return {
      serviceCenter: cloneDeep(defaultServiceCenter),
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("serviceCenters/get", id);
        this.serviceCenter =
          this.$store.getters["serviceCenters/serviceCenter"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    goBack() {
      this.$router.push({ name: "List ServiceCenters" });
    },

    viewServiceCenter() {
      this.alertLeave = false;
      this.$router.push({
        name: "View ServiceCenter",
        params: { id: this.serviceCenter.id },
      });
    },

    async handleSubmit(serviceCenter) {
      this.loading = true;
      const serviceCenterData = cloneDeep(serviceCenter);

      try {
        await this.$store.dispatch("serviceCenters/update", serviceCenterData);
        this.$notify({
          type: "success",
          message: this.$t("SERVICECENTERS.SERVICECENTER_UPDATED"),
        });
        this.viewServiceCenter();
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
